export default "__VITE_ASSET__CYtOt86T__"